import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsDateTime } from './generic-modal.service';
import { DatetimePickerComponent } from '../datetime-picker/datetime-picker.component';

@Component({
    selector: 'ep-modal-datetime',
    templateUrl: './modal-datetime.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatetimePickerComponent]
})
export class ModalDateTime {
    options: ModalSettingsDateTime;

    currentDate: Date;
    currentTime: string;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsDateTime;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        if (this.options.type == 'date' || this.options.type == 'datetime') {
            this.modalState.modal.close(this.currentDate);
        }
        else {
            this.modalState.modal.close(this.currentTime);
        }
    }
}